import { call, cancelled, delay, put } from 'redux-saga/effects';

import { httpApiService } from 'app/api';

import { applyLiveStreamEntries } from './actions';

const LIVE_STREAM_REQUEST_INTERVAL = 30000; // once per 30 seconds
let liveStreamRequestIntervalCurrent = LIVE_STREAM_REQUEST_INTERVAL;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Translation = any;

export default function* liveStreamRequestSaga(): Generator {
  let prevResponseText = null;

  while (true) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = yield call(() => httpApiService.get('/api/live/streams'));
      const text = JSON.stringify(response.data);

      if (text && response.data && text !== prevResponseText) {
        liveStreamRequestIntervalCurrent = LIVE_STREAM_REQUEST_INTERVAL;
        prevResponseText = text;
        const filteredBody = response.data.filter((translation: Translation) => translation.type !== 'img');
        yield put(applyLiveStreamEntries(filteredBody));
      }
    }
    catch (err) {
      if (!(yield cancelled())) {
        console.error('liveStreamRequestSaga -> live streams request failed:', err); // >>>
        liveStreamRequestIntervalCurrent += LIVE_STREAM_REQUEST_INTERVAL;
      }
    }

    yield delay(liveStreamRequestIntervalCurrent);
  }
}
